import { AUTO_SUBMIT_FORM, USER_SUBMIT_FORM } from "./form-submitted-action-types";

const formSubmittedReducer = (state = false, action) => {
    switch (action.type) {
        case USER_SUBMIT_FORM:
            return true;
        case AUTO_SUBMIT_FORM:
            return {
                ...state,
                ...action.submitData
            };
        default:
            return state;
    }
};

export default formSubmittedReducer;
